export const formatPayrollAmount = (value, { signed = false } = {}) => {
  const numeric = Number(value || 0);
  const formatted = Math.abs(numeric).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  if (!signed) return formatted;
  if (numeric > 0) return `+${formatted}`;
  if (numeric < 0) return `-${formatted}`;
  return formatted;
};

export const formatPayrollCurrency = (value, currency = "SAR") => {
  const numeric = Number(value || 0);
  const formatted = numeric.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return `${formatted} ${currency}`;
};
